import { useRef } from 'react';
import { Alert, AlertDescription, Button } from '@roger/ui-components';
import { AlertTriangle, Download } from 'lucide-react';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';
import AdoptionReport, {
  type AdoptionReportRef,
} from '../components/reports/AdoptionReport';

const Reporting = () => {
  const { hasPermission } = useStore(
    useShallow(state => ({
      hasPermission: state.hasPermission,
    }))
  );
  const adoptionReportRef = useRef<AdoptionReportRef>(null);

  const handleExport = () => {
    adoptionReportRef.current?.exportToCSV();
  };

  if (!hasPermission('reports:access')) {
    return (
      <div className='container mx-auto px-4 py-6'>
        <Alert className='border-red-200 bg-red-50'>
          <AlertTriangle className='h-4 w-4 text-red-600' />
          <AlertDescription className='text-red-800'>
            You don't have permission to access Reports features. Please contact
            your administrator if you need access.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className='space-y-6'>
      {/* Header */}
      <div className='flex justify-between items-center'>
        <div>
          <h1 className='text-2xl font-bold'>Reports</h1>
          <p className='text-muted-foreground text-sm'>
            Clinician adoption metrics and usage analytics
          </p>
        </div>
        <Button
          variant='outline'
          className='px-3 text-xs'
          onClick={handleExport}
          size='default'
        >
          <Download className='h-4 w-4' />
          Download Report
        </Button>
      </div>

      {/* Adoption Report */}
      <AdoptionReport ref={adoptionReportRef} />
    </div>
  );
};

export default Reporting;
